var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container,attrs:{"id":"description"}},[_c('h2',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.$t("descriptionSection.title")))]),_c('p',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t("descriptionSection.text"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }